"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var reconnect_js_1 = require("reconnect.js");
var Config_1 = require("../../Config");
var LoginForm_1 = __importDefault(require("../LoginForm"));
var NavUrl_1 = __importDefault(require("../../Utils/NavUrl"));
function LoginModal(props) {
  var _this = this;
  var _a = props.title,
    title = _a === void 0 ? '' : _a,
    _b = props.adminTitle,
    adminTitle = _b === void 0 ? '' : _b,
    _c = props.canNormalLogin,
    canNormalLogin = _c === void 0 ? true : _c,
    _d = props.canFacebookLogin,
    canFacebookLogin = _d === void 0 ? true : _d,
    _e = props.canGoogleLogin,
    canGoogleLogin = _e === void 0 ? true : _e,
    _f = props.canLineLogin,
    canLineLogin = _f === void 0 ? true : _f,
    _g = props.onBeforeLoginClick,
    onBeforeLoginClick = _g === void 0 ? function () {
      return true;
    } : _g,
    _h = props.onRegisterClick,
    onRegisterClick = _h === void 0 ? function () {
      return 0;
    } : _h,
    _j = props.onForgotPasswordClick,
    onForgotPasswordClick = _j === void 0 ? function () {
      return 0;
    } : _j,
    _k = props.renderExtra,
    renderExtra = _k === void 0 ? null : _k;
  var _l = (0, reconnect_js_1.useOutlet)('login-modal'),
    info = _l[0],
    setVisible = _l[1];
  var actions = (0, reconnect_js_1.useOutlet)('actions')[0];
  var visible = !!info;
  var admin = info && info.admin;
  return react_1.default.createElement(antd_1.Modal, {
    title: null,
    footer: null,
    bodyStyle: {
      padding: 0
    },
    width: 450,
    visible: visible,
    onOk: function () {
      setVisible(false);
    },
    onCancel: function () {
      setVisible(false);
    },
    destroyOnClose: true
  }, react_1.default.createElement(Wrapper, null, react_1.default.createElement(Center, null, react_1.default.createElement(LoginForm_1.default, {
    admin: admin,
    formTitle: title,
    adminFormTitle: adminTitle,
    onBeforeLoginClick: onBeforeLoginClick,
    canFacebookLogin: canFacebookLogin,
    canGoogleLogin: canGoogleLogin,
    canLineLogin: canLineLogin,
    canNormalLogin: canNormalLogin,
    onSucceed: function () {
      return setVisible(false);
    },
    renderExtra: renderExtra
  }), !admin && canNormalLogin && react_1.default.createElement(Container, {
    style: {
      padding: 0
    }
  }, react_1.default.createElement("div", {
    className: "text-style"
  }, "\u9084\u6C92\u6709\u5E33\u865F\uFF1F"), react_1.default.createElement(antd_1.Button, {
    className: "text-style",
    type: "link",
    size: "small",
    onClick: function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (typeof onRegisterClick === 'function') {
                onRegisterClick();
                return [2 /*return*/];
              }
              _a.label = 1;
            case 1:
              _a.trys.push([1,, 3, 4]);
              actions.setLoading(true);
              actions.navigate(new NavUrl_1.default('/register/request'));
              return [4 /*yield*/, actions.delay(600)];
            case 2:
              _a.sent();
              return [3 /*break*/, 4];
            case 3:
              setVisible(false);
              actions.setLoading(false);
              return [7 /*endfinally*/];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    }
  }, "\u7ACB\u5373\u8A3B\u518A")), !admin && canNormalLogin && (0, Config_1.get)().primaryUserType !== 'username' && react_1.default.createElement(Container, {
    style: {
      paddingBottom: 0
    }
  }, react_1.default.createElement("div", {
    className: "text-style"
  }, "\u5FD8\u8A18\u5BC6\u78BC\uFF1F"), react_1.default.createElement(antd_1.Button, {
    className: "text-style",
    type: "link",
    size: "small",
    onClick: function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (typeof onForgotPasswordClick === 'function') {
                onForgotPasswordClick();
                return [2 /*return*/];
              }
              _a.label = 1;
            case 1:
              _a.trys.push([1,, 3, 4]);
              actions.setLoading(true);
              actions.navigate(new NavUrl_1.default('/forgot-password/request'));
              return [4 /*yield*/, actions.delay(600)];
            case 2:
              _a.sent();
              return [3 /*break*/, 4];
            case 3:
              setVisible(false);
              actions.setLoading(false);
              return [7 /*endfinally*/];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    }
  }, "\u91CD\u65B0\u8A2D\u5B9A")))));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 40px;\n"], ["\n  padding: 40px;\n"])));
var Center = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 300px;\n  width: 100%;\n  margin: 0 auto;\n\n  & > h2 {\n    margin-bottom: 20px;\n    font-size: 25px;\n    color: #000000;\n    letter-spacing: 3px;\n    line-height: 25px;\n  }\n\n  & .input-style {\n    border: 1px solid #e5e5ea;\n    border-radius: 5px;\n    padding: 10px 15px;\n    height: 45px;\n  }\n\n  & .button-style {\n    box-shadow: 0 5px 8px 0 lightgray;\n    border-radius: 10px;\n    padding: 9px;\n    width: 100%;\n    height: 40px;\n    font-weight: 500;\n    font-size: 15px;\n  }\n"], ["\n  max-width: 300px;\n  width: 100%;\n  margin: 0 auto;\n\n  & > h2 {\n    margin-bottom: 20px;\n    font-size: 25px;\n    color: #000000;\n    letter-spacing: 3px;\n    line-height: 25px;\n  }\n\n  & .input-style {\n    border: 1px solid #e5e5ea;\n    border-radius: 5px;\n    padding: 10px 15px;\n    height: 45px;\n  }\n\n  & .button-style {\n    box-shadow: 0 5px 8px 0 lightgray;\n    border-radius: 10px;\n    padding: 9px;\n    width: 100%;\n    height: 40px;\n    font-weight: 500;\n    font-size: 15px;\n  }\n"])));
var Container = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 10px 0px;\n  display: flex;\n  align-items: center;\n\n  & .text-style {\n    padding: 0px;\n    line-height: 20px;\n    font-size: 13px;\n  }\n"], ["\n  padding: 10px 0px;\n  display: flex;\n  align-items: center;\n\n  & .text-style {\n    padding: 0px;\n    line-height: 20px;\n    font-size: 13px;\n  }\n"])));
exports.default = LoginModal;
var templateObject_1, templateObject_2, templateObject_3;